"use client";

import { useToggleMap } from "@repo/design-system/hooks/use-toggle-map";
import { cn } from "@repo/design-system/utils/cn";
import { SVGLocationPin } from "~/components/icons/location-pin-eon";
import { Button, type ButtonProps } from "~/components/ui/button-eon";
import { useLanguage } from "~/translations/loader/use-language";
export function ToggleMap({
  variant = "ghost",
  className
}: {
  variant?: ButtonProps["variant"];
  className?: string;
}) {
  const t = useLanguage();
  const {
    hasMounted,
    isMapVisible,
    toggleMap,
    onAnimationIteration,
    showMapAnimation
  } = useToggleMap({
    initiallyOpen: false
  });
  const buttonText = hasMounted && isMapVisible ? t.filterbar_mapToggleButtonExpanded : t.filterbar_mapToggleButton;
  return <Button className={cn("justify-between", className)} onClick={toggleMap} onMouseEnter={() => import("../map/leaflet-map")} variant={variant}>
      <div />
      <span className="px-2">{buttonText}</span>
      <SVGLocationPin className={cn(showMapAnimation && !isMapVisible && "animate-bounce", "size-5")} onAnimationIteration={onAnimationIteration} />
    </Button>;
}